<script setup lang="ts"></script>
<template>
    <ul>
        <slot></slot>
    </ul>
</template>
